import React, { useState } from 'react';
import { Input, Drawer, Dropdown } from 'antd';
import {
  UserOutlined,
  HeartOutlined,
  ShoppingCartOutlined,
  EnvironmentOutlined,
  MenuOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { useHistory, Link } from 'react-router-dom';

import logoHorizontal from '../../../assets/images/logo-horizontal-green.png';
import { useAuth } from '../../../context/AuthContext';

import {
  HeaderWrapper,
  TopBar,
  MainBar,
  Logo,
  LogoImage,
  SearchWrapper,
  IconGroup,
  IconLink,
  CartBadge,
  NavBar,
  NavInner,
  NavLink,
  MobileMenuButton,
  DesktopNav,
  DesktopSearch,
} from './styles';

export default function Header() {
  const [searchQuery, setSearchQuery] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const history = useHistory();
  const { user, logout } = useAuth();

  const handleSearch = (value) => {
    if (value.trim()) {
      history.push(`/buscar?q=${encodeURIComponent(value.trim())}`);
      setSearchQuery('');
    }
  };

  const handleLogout = () => {
    logout();
    history.push('/');
  };

  const userMenuItems = [
    {
      key: 'cuenta',
      label: <Link to="/cuenta">Mi Cuenta</Link>,
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Cerrar sesión',
      onClick: handleLogout,
    },
  ];

  const navLinks = [
    { to: '/buscar', label: 'Comprar' },
    { to: '/registro', label: 'Vender' },
    { to: '#', label: 'Blog' },
    { to: '#', label: 'Contacto' },
    { to: '#', label: 'Ubicaciones' },
  ];

  return (
    <HeaderWrapper>
      <TopBar>
        Bienvenido a Red de Estantes — Tu comunidad de libros en Costa Rica
      </TopBar>

      <MainBar>
        <Logo to="/">
          <LogoImage src={logoHorizontal} alt="Red de Estantes" />
        </Logo>

        <DesktopSearch>
          <SearchWrapper>
            <Input.Search
              placeholder="Buscar por título, autor, ISBN..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onSearch={handleSearch}
              enterButton
              size="large"
            />
          </SearchWrapper>
        </DesktopSearch>

        <IconGroup>
          {user ? (
            <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
              <IconLink to="/cuenta" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <UserOutlined />
                <span style={{ fontSize: 13, maxWidth: 80, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {user.name.split(' ')[0]}
                </span>
              </IconLink>
            </Dropdown>
          ) : (
            <IconLink to="/ingresar">
              <UserOutlined />
            </IconLink>
          )}
          <IconLink to="/cuenta?tab=favoritos">
            <HeartOutlined />
          </IconLink>
          <IconLink to="/carrito">
            <ShoppingCartOutlined />
            <CartBadge>2</CartBadge>
          </IconLink>
          <MobileMenuButton onClick={() => setMobileMenuOpen(true)}>
            <MenuOutlined />
          </MobileMenuButton>
        </IconGroup>
      </MainBar>

      <DesktopNav>
        <NavBar>
          <NavInner>
            {navLinks.map((link) => (
              <NavLink key={link.label} to={link.to}>
                {link.label}
              </NavLink>
            ))}
            <NavLink to="#">
              <EnvironmentOutlined style={{ marginRight: 4 }} />
              Ubicaciones
            </NavLink>
          </NavInner>
        </NavBar>
      </DesktopNav>

      <Drawer
        title="Menú"
        placement="left"
        onClose={() => setMobileMenuOpen(false)}
        open={mobileMenuOpen}
      >
        <div style={{ marginBottom: 16 }}>
          <Input.Search
            placeholder="Buscar..."
            onSearch={(val) => {
              handleSearch(val);
              setMobileMenuOpen(false);
            }}
          />
        </div>
        {navLinks.map((link) => (
          <div key={link.label} style={{ padding: '12px 0' }}>
            <NavLink
              to={link.to}
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </NavLink>
          </div>
        ))}
      </Drawer>
    </HeaderWrapper>
  );
}
